<template>
  <v-card
    tile
    class="mtfont"
  >
    <div class="video-header">
      <video autoplay muted="muted" loop>
        <source src="https://cdn.shopify.com/s/files/1/2636/4748/files/MIXING.mp4?v=1617835438" type="video/mp4">
      </video>
    </div>

    <v-container class="pa-6" id="FormulaPrintArea">
      <v-row>
        <v-col cols="7" class="py-0">FN-INK PANTONE FORMULA:</v-col>
        <v-col cols="5" class="py-0">{{ this.$store.getters.getCurrentUserFavorite.customName || ($store.getters.getCurrentUserFavorite.color? 'PANTONE ' + $store.getters.getCurrentUserFavorite.color.code: 'PANTONE')}}</v-col>
      </v-row>
      <v-row>
        <v-col cols="7" class="py-0">
          <v-text-field
              v-model="totalGrams"
              dense
              outlined
              suffix="grams"
              style="max-width: 150px"
          ></v-text-field></v-col>
        <v-col cols="5" class="py-0"><small>{{ (new Date()).toLocaleDateString() }}</small></v-col>
      </v-row>

      <v-simple-table style="border: 1px solid lightgrey;" class="mt-2">
          <template >
            <thead>
              <tr>
                <th class="text-center">
                  COLOR
                </th>
                <th class="text-left">
                  NAME
                </th>
                <th class="text-right">
                  AMOUNT(g)
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in mats"
                :key="item.name"
              >
                <td width="20px"> <LighteningBoltIndicater :hexColor="item.material.hex" /> </td>
                <td>{{ item.material.name }}</td>
                <td class="text-right">{{ materialAmount(item.amount) }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
    </v-container>

    <v-card-actions>
      <div class="pa-2">Version <br/>{{versionToDate(this.$store.getters.getCurrentUserFavorite.version)}}</div>

      <v-spacer></v-spacer>
      <v-btn
        depressed
        color="black"
        style="color: #fecb39;"
        large
        class="mb-3 mr-3"
        v-on:click="printDiv"
      >PRINT FORMULA</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import LighteningBoltIndicater from '@/components/Admin/LighteningBoltSwatch.vue';

  export default {
    name: 'FormulaCard',

    components: {
      LighteningBoltIndicater
    },

    data: () => ({
      version: null,
      materials: [],
      totalGrams: 100,
      multiplier: 100
    }),
    created() {
      const self = this;
      setTimeout(_=>{
        self.getMaterials();
      }, 1000);
    },
    computed: {
      versions() {
        if(!this.$store.getters.getCurrentColor.formula) return [];

        const history = this.$store.getters.getCurrentColor.formula.history;
        this.version = this.$store.getters.getCurrentColor.formula.createdAt;

        return [this.$store.getters.getCurrentColor.formula, ...history];
      },
      currentColor() {
        return this.$store.getters.getCurrentColor || {};
      },
      materialAmount() {
        return amount => (+amount * (this.totalGrams/this.multiplier)).toFixed(2);
      },
      mats() {
        return this.$store.getters.getCurrentUserFavorite.materials;
      }
    },
    methods: {
      getMaterials() {
        const favorite = this.$store.getters.getCurrentUserFavorite;
        if(!favorite) return [];

        this.$store.dispatch('getFavoriteFormula', favorite.formula.id)
          .then(result => {
            this.materials = result.data.formula.materials
            this.totalGrams = 100;
            this.multiplier = favorite.formula.multiplier;
          })
          .catch(e => {
            console.error(e);
            this.materials = [];
          });

        /*
        return !formula? []: formula.materials.map( material => ({
          code: material.material.code,
          name: material.material.name,
          amount: ((+material.amount * +this.totalGrams)/+this.currentColor.formula.multiplier).toFixed(2),
          hex: material.material.hex
        }));*/
      },
      changeFormulaVersion: function(event) {
        this.version = event;
      },
      versionToDate: function(value) {
        return new Date(+value).toLocaleDateString();
      },
      printDiv: function() { 
        var divContents = document.getElementById("FormulaPrintArea").innerHTML;
        var a = window.open('', '', 'height=600, width=900'); 
        a.document.write(`<html><head>
          <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Montserrat:wght@900">
          <link href="https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css" rel="stylesheet">
          </head><body style="padding: 10px;"><v-container style="font-family: 'Montserrat', sans-serif;">`);
        a.document.write(divContents);
        a.document.write(`<br><small style="color:grey;">Version: ${new Date(+this.version).toLocaleDateString()}</small>`);
        a.document.write('</v-container></body></html>');
        a.document.close();
        setTimeout(function(){ a.print(); a.close(); }, 600);
      }
    }
  }
</script>

<style scoped>
.video-header {
  width: 100%;
  overflow: hidden;
  display:block;
  height: 70px;
}
</style>
